// src/components/ThemeToggle.js

// Importe React pour créer des composants
import React from 'react';
// Importe le hook personnalisé useTheme pour accéder au contexte du thème
import { useTheme } from '../contexts/ThemeContext';
// Importe le hook useTranslation de react-i18next pour les traductions
import { useTranslation } from 'react-i18next';

// Composant pour basculer entre le thème clair et le thème sombre
const ThemeToggle = ({ mobile = false }) => {
  // Utilise le hook useTheme pour obtenir le thème actuel et la fonction pour le changer
  const { theme, toggleTheme } = useTheme();
  // Utilise le hook useTranslation pour accéder à la fonction de traduction 't'
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={toggleTheme} // Appelle toggleTheme lorsque le bouton est cliqué
      className={`${mobile ? 'p-2' : 'p-0.5'
        } rounded-full bg-light-primary hover:bg-light-primary/80 text-white shadow-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-light-secondary dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-500`}
      aria-label={t('toggle_theme')} // Utilise la traduction pour l'accessibilité
      title={t('toggle_theme')} // Utilise la traduction pour le tooltip
    >
      {/* Affiche une icône ou un texte basé sur le thème actuel */}
      {theme === 'light' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 3v1m0 16v1m9-9h1M3 12H2m8.003-4.373l.707-.707M15.293 15.293l.707.707M5.636 5.636l-.707-.707m12.728 12.728l-.707-.707M6 12a6 6 0 1112 0 6 6 0 01-12 0z"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;
